import { useContext, useEffect, useMemo, useRef } from "react";

// Contexts
import { CartContext } from "@cart-client/contexts/CartContext";

// Types
import { PresentationInfo } from "@swiggy-private/cart-types";

// Utils
import { getCloudinaryRawUrl, getNestedValue } from "@swiggy-private/js-utils";
import { isSwiggyBlack } from "@swiggy-private/super-ui";

// Constants
import { LOTTIE_ASSETS, SOUND_ASSETS } from "@swiggy-private/core-ui";
import { isPopFlow } from "@swiggy-private/checkout-core";

export const usePrefetchBlckTickLottie = () => {
    const { cartState } = useContext(CartContext);
    const { reviewedCart: cartResponse } = cartState;
    const transitionLottieFetchRef = useRef<boolean>(false);
    const isPopCart = isPopFlow();

    const swiggyPlanInfo = useMemo(
        () => getNestedValue(cartResponse, "data.swiggyOneInfo.presentationInfo", {} as PresentationInfo),
        [cartResponse],
    );

    const isBlackMembershipPlan = useMemo(() => {
        const { plan_details: planDetails, active_plan_details: activePlanDetals } = swiggyPlanInfo || {};
        return isSwiggyBlack(planDetails) || isSwiggyBlack(activePlanDetals);
    }, [swiggyPlanInfo]);

    const isBlackOTPApplicable = useMemo(() => getNestedValue(cartResponse, "data.swiggyBlackOTPApplicable", false), [
        cartResponse,
    ]);

    useEffect(() => {
        if (isBlackMembershipPlan && isBlackOTPApplicable && !transitionLottieFetchRef.current) {
            const lottieAsset = fetch(getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID_BLACK_OTP) || "");
            const soundAsset = fetch(getCloudinaryRawUrl(SOUND_ASSETS.TRING_SOUND) || "");

            Promise.all([lottieAsset, soundAsset])
                .then(() => {
                    transitionLottieFetchRef.current = true;
                })
                .catch();
        }

        if (isBlackMembershipPlan && !transitionLottieFetchRef.current) {
            fetch(getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID_BLACK) || "")
                .then(() => {
                    transitionLottieFetchRef.current = true;
                })
                .catch();
        }

        if (isPopCart && !transitionLottieFetchRef.current) {
            fetch(getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID_POP) || "")
                .then(() => {
                    transitionLottieFetchRef.current = true;
                })
                .catch();
        }
    }, [isBlackMembershipPlan, isBlackOTPApplicable, isPopCart]);
};
